var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "OTA Files", name: "files" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showUploadModal },
                },
                [_vm._v("Upload OTA")]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.uploadModalVisible,
                    title: "Upload OTA v2",
                    width: "70%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.uploadModalVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "otaForm",
                      attrs: {
                        model: _vm.otaForm,
                        rules: _vm.rules,
                        "label-width": "200px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Beta Groups" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                multiple: "",
                                placeholder: _vm.$t(
                                  "otaFilesExtra.stableAllUsers"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.otaForm.groupIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.otaForm, "groupIds", $$v)
                                },
                                expression: "otaForm.groupIds",
                              },
                            },
                            _vm._l(_vm.selectableGroups, function (g) {
                              return _c("el-option", {
                                key: g.id,
                                attrs: { label: g.groupName, value: g.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "8px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.groupCreateHint")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Install Priority",
                            prop: "installOrder",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Select Priority" },
                              model: {
                                value: _vm.otaForm.installOrder,
                                callback: function ($$v) {
                                  _vm.$set(_vm.otaForm, "installOrder", $$v)
                                },
                                expression: "otaForm.installOrder",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Wireless", value: "Wireless" },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Application",
                                  value: "Application",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Wireless File",
                            prop: "wirelessFile",
                          },
                        },
                        [
                          _c("input", {
                            attrs: { type: "file" },
                            on: { change: _vm.handleWirelessFileChange },
                          }),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Application File",
                            prop: "applicationFile",
                          },
                        },
                        [
                          _c("input", {
                            attrs: { type: "file" },
                            on: { change: _vm.handleApplicationFileChange },
                          }),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Wireless Version",
                            prop: "wirelessVersionName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: {
                              placeholder: "Enter Wireless Version Name",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.validateVersionInput(
                                  "wirelessVersionName"
                                )
                              },
                            },
                            model: {
                              value: _vm.otaForm.wirelessVersionName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.otaForm,
                                  "wirelessVersionName",
                                  $$v
                                )
                              },
                              expression: "otaForm.wirelessVersionName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Application Version",
                            prop: "applicationVersionName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: {
                              placeholder: "Enter Application Version Name",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.validateVersionInput(
                                  "applicationVersionName"
                                )
                              },
                            },
                            model: {
                              value: _vm.otaForm.applicationVersionName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.otaForm,
                                  "applicationVersionName",
                                  $$v
                                )
                              },
                              expression: "otaForm.applicationVersionName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Description" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.otaForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.otaForm, "description", $$v)
                              },
                              expression: "otaForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Release Notes" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.otaForm.releaseNotes,
                              callback: function ($$v) {
                                _vm.$set(_vm.otaForm, "releaseNotes", $$v)
                              },
                              expression: "otaForm.releaseNotes",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mandatory Update" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.otaForm.isMandatory,
                              callback: function ($$v) {
                                _vm.$set(_vm.otaForm, "isMandatory", $$v)
                              },
                              expression: "otaForm.isMandatory",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Rollout Strategy" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.otaForm.rolloutStrategy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.otaForm, "rolloutStrategy", $$v)
                                },
                                expression: "otaForm.rolloutStrategy",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "random" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("otaFilesExtra.rolloutRandom"))
                                ),
                              ]),
                              _c(
                                "el-radio",
                                { attrs: { label: "first_come" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("otaFilesExtra.rolloutFirstCome")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                                "margin-top": "4px",
                                "line-height": "1.4",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.rolloutRandomHelp")
                                  )
                              ),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.rolloutFirstComeHelp")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.otaForm.rolloutStrategy === "random"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Rollout Percentage" } },
                            [
                              _c("el-slider", {
                                staticStyle: { width: "80%" },
                                attrs: { min: 0, max: 100, "show-input": "" },
                                model: {
                                  value: _vm.otaForm.rolloutPercentage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.otaForm,
                                      "rolloutPercentage",
                                      $$v
                                    )
                                  },
                                  expression: "otaForm.rolloutPercentage",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("otaFilesExtra.firstNUsers"),
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 1, max: 100000, step: 1 },
                                model: {
                                  value: _vm.otaForm.rolloutPercentage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.otaForm,
                                      "rolloutPercentage",
                                      $$v
                                    )
                                  },
                                  expression: "otaForm.rolloutPercentage",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "8px",
                                    color: "#909399",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("otaFilesExtra.firstNUsersHint")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("otaFiles.pinOnly") } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.otaForm.isPinOnly,
                              callback: function ($$v) {
                                _vm.$set(_vm.otaForm, "isPinOnly", $$v)
                              },
                              expression: "otaForm.isPinOnly",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("otaFiles.pinOnlyCreateHint")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("otaFiles.overridesOlderPins"),
                          },
                        },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.otaForm.overridesOlderPins,
                              callback: function ($$v) {
                                _vm.$set(_vm.otaForm, "overridesOlderPins", $$v)
                              },
                              expression: "otaForm.overridesOlderPins",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFiles.overridesOlderPinsHint")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.uploadModalVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: { click: _vm.submitOtaVersion },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.editModalVisible,
                    title: "Edit OTA File",
                    width: "50%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.editModalVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.editForm, "label-width": "180px" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Active" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.editForm.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "isActive", $$v)
                              },
                              expression: "editForm.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Beta Groups" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "60%" },
                              attrs: {
                                multiple: "",
                                placeholder: _vm.$t(
                                  "otaFilesExtra.stableAllUsers"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.editForm.groupIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "groupIds", $$v)
                                },
                                expression: "editForm.groupIds",
                              },
                            },
                            _vm._l(_vm.selectableGroups, function (g) {
                              return _c("el-option", {
                                key: g.id,
                                attrs: { label: g.groupName, value: g.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.groupEditHint")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mandatory Update" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.editForm.isMandatory,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "isMandatory", $$v)
                              },
                              expression: "editForm.isMandatory",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Rollout Strategy" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.editForm.rolloutStrategy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "rolloutStrategy", $$v)
                                },
                                expression: "editForm.rolloutStrategy",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "random" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("otaFilesExtra.rolloutRandom"))
                                ),
                              ]),
                              _c(
                                "el-radio",
                                { attrs: { label: "first_come" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("otaFilesExtra.rolloutFirstCome")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.editForm.rolloutStrategy === "random"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Rollout Percentage" } },
                            [
                              _c("el-slider", {
                                staticStyle: { width: "80%" },
                                attrs: { min: 0, max: 100, "show-input": "" },
                                model: {
                                  value: _vm.editForm.rolloutPercentage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editForm,
                                      "rolloutPercentage",
                                      $$v
                                    )
                                  },
                                  expression: "editForm.rolloutPercentage",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("otaFilesExtra.firstNUsers"),
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { min: 1, max: 100000, step: 1 },
                                model: {
                                  value: _vm.editForm.rolloutPercentage,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editForm,
                                      "rolloutPercentage",
                                      $$v
                                    )
                                  },
                                  expression: "editForm.rolloutPercentage",
                                },
                              }),
                            ],
                            1
                          ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Release Notes" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.editForm.releaseNotes,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "releaseNotes", $$v)
                              },
                              expression: "editForm.releaseNotes",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Description" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 2 },
                            model: {
                              value: _vm.editForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "description", $$v)
                              },
                              expression: "editForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("otaFiles.pinOnly") } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.editForm.isPinOnly,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "isPinOnly", $$v)
                              },
                              expression: "editForm.isPinOnly",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("otaFiles.pinOnlyEditHint")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("otaFiles.overridesOlderPins"),
                          },
                        },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.editForm.overridesOlderPins,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editForm,
                                  "overridesOlderPins",
                                  $$v
                                )
                              },
                              expression: "editForm.overridesOlderPins",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "12px",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFiles.overridesOlderPinsHint")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.editModalVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.editLoading },
                          on: { click: _vm.submitEdit },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.logsModalVisible,
                    title: "Download Logs - " + _vm.logsVersionLabel,
                    width: "80%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.logsModalVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "12px",
                        display: "flex",
                        "align-items": "center",
                        gap: "8px",
                      },
                    },
                    [
                      _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("otaFilesExtra.totalRequests", {
                                n:
                                  _vm.logsPagination.totalRequests ||
                                  _vm.logsPagination.total,
                              })
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: "info",
                            size: "small",
                            effect: "plain",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$tc(
                                  "otaFilesExtra.groupCount",
                                  _vm.logsPagination.total,
                                  { n: _vm.logsPagination.total }
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-tag",
                        { attrs: { type: "success", size: "small" } },
                        [
                          _vm._v(
                            "Unique Users: " + _vm._s(_vm.logsUniqueUserCount)
                          ),
                        ]
                      ),
                      _c(
                        "el-tag",
                        { attrs: { type: "warning", size: "small" } },
                        [
                          _vm._v(
                            "Unique Devices: " +
                              _vm._s(_vm.logsUniqueDeviceCount)
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "auto" },
                          attrs: {
                            size: "mini",
                            type: "success",
                            icon: "el-icon-download",
                            loading: _vm.logsExporting,
                          },
                          on: { click: _vm.exportLogsToExcel },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("otaFilesExtra.exportToExcel")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.logsLoading,
                          expression: "logsLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.downloadLogs,
                        border: "",
                        size: "small",
                        "max-height": "500",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("otaFilesExtra.lastRequest"),
                          width: "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        row.last_at || row.created_at
                                      )
                                    )
                                  ),
                                ]),
                                row.request_count > 1 && row.first_at
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "11px",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("otaFilesExtra.firstAt", {
                                                date: _vm.formatDate(
                                                  row.first_at
                                                ),
                                              })
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("otaFilesExtra.requests"),
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type:
                                        (row.request_count || 1) > 1
                                          ? "warning"
                                          : "info",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(row.request_count || 1) + " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("otaFilesExtra.userDevice"),
                          "min-width": "280",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.user
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.userTooltip(row.user),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "line-height": "1.3",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  row.user.email || row.userId
                                                )
                                              ),
                                            ]),
                                            row.user.firstName ||
                                            row.user.lastName
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "11px",
                                                      color: "#909399",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          (
                                                            row.user
                                                              .firstName || ""
                                                          ).trim()
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          (
                                                            row.user.lastName ||
                                                            ""
                                                          ).trim()
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-family": "monospace",
                                          "font-size": "11px",
                                          color: "#909399",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(row.userId) + " ")]
                                    ),
                                row.deviceSerialNumber
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "3px" } },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "font-family": "monospace",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                              effect: "plain",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " 📎 " +
                                                _vm._s(row.deviceSerialNumber) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "App Version",
                          width: "120",
                          prop: "applicationVersionName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Wireless Version",
                          width: "130",
                          prop: "wirelessVersionName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Requested Ver.",
                          width: "120",
                          prop: "requestedMajorVersion",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "IP Address",
                          width: "140",
                          prop: "ipAddress",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "User Agent",
                          prop: "userAgent",
                          "show-overflow-tooltip": "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.logsPagination.total > _vm.logsPagination.limit
                    ? _c("el-pagination", {
                        staticStyle: { "margin-top": "12px" },
                        attrs: {
                          "current-page": _vm.logsPagination.page,
                          "page-size": _vm.logsPagination.limit,
                          layout: "total, prev, pager, next",
                          total: _vm.logsPagination.total,
                        },
                        on: { "current-change": _vm.handleLogsPageChange },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { margin: "15px 0" } },
                [
                  _c("span", { staticStyle: { "margin-right": "8px" } }, [
                    _vm._v("Filter by Group:"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "All",
                        clearable: "",
                        size: "small",
                      },
                      on: { change: _vm.applyFilter },
                      model: {
                        value: _vm.filterGroupId,
                        callback: function ($$v) {
                          _vm.filterGroupId = $$v
                        },
                        expression: "filterGroupId",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Stable (No Group)", value: "default" },
                      }),
                      _vm._l(_vm.betaGroups, function (g) {
                        return _c("el-option", {
                          key: g.id,
                          attrs: { label: g.groupName, value: g.id },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.paginatedList,
                    "element-loading-text": "Loading...",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Uploaded", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.formatDate(
                                    row.wirelessUploadDate
                                  ),
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", { staticClass: "upload-date" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDay(row.wirelessUploadDate)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Wireless Ver.", width: "115" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s(row.wirelessVersionName))]
                            ),
                            row.wirelessAwsUrl
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Download Wireless",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "file-download",
                                        attrs: {
                                          href: row.wirelessAwsUrl,
                                          target: "_blank",
                                          "aria-label":
                                            "Download wireless " +
                                            row.wirelessVersionName,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "App Ver.", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v(_vm._s(row.applicationVersionName))]
                            ),
                            row.applicationAwsUrl
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Download Application",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "file-download",
                                        attrs: {
                                          href: row.applicationAwsUrl,
                                          target: "_blank",
                                          "aria-label":
                                            "Download application " +
                                            row.applicationVersionName,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            row.isPinOnly
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: { "margin-left": "4px" },
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      title: _vm.$t(
                                        "otaFilesExtra.pinOnlyTagHint"
                                      ),
                                    },
                                  },
                                  [_vm._v("Pin-only")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Groups", "min-width": "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.betaGroups && row.betaGroups.length
                              ? _vm._l(row.betaGroups, function (g) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: g.id,
                                      staticStyle: { margin: "0 4px 4px 0" },
                                      attrs: { size: "small" },
                                    },
                                    [_vm._v(" " + _vm._s(g.groupName) + " ")]
                                  )
                                })
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "small" } },
                                  [_vm._v("Stable")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Order", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(" " + _vm._s(row.installOrder) + " ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Active", width: "62", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isActive ? "success" : "danger",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(row.isActive ? "Y" : "N") + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Mandatory", width: "98", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.isMandatory ? "danger" : "info",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(row.isMandatory ? "Yes" : "No") +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Rollout", width: "75", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.rolloutStrategy === "first_come"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("otaFilesExtra.rolloutFirstN", {
                                        n: row.rolloutPercentage,
                                      })
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      row.rolloutPercentage !== null &&
                                        row.rolloutPercentage !== undefined
                                        ? row.rolloutPercentage + "%"
                                        : "100%"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Description",
                      "min-width": "90",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(" " + _vm._s(row.description || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Release Notes",
                      "min-width": "90",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(" " + _vm._s(row.releaseNotes || "-") + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Actions",
                      width: "180",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "row-actions" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Download Logs",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        size: "mini",
                                        type: "info",
                                        icon: "el-icon-download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDownloadLogs(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "otaFilesExtra.managePins"
                                      ),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        size: "mini",
                                        type: "warning",
                                        icon: "el-icon-paperclip",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showPinManager(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showEditModal(row)
                                    },
                                  },
                                }),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDelete(row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.pinDrawerVisible,
                    title: _vm.pinDrawerTitle,
                    direction: "rtl",
                    size: "640px",
                    "before-close": _vm.closePinDrawer,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.pinDrawerVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { padding: "0 20px" } },
                    [
                      _vm.pinDrawerOta
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "16px" } },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pinDrawerOta.applicationVersionName
                                  )
                                ),
                              ]),
                              _vm.pinDrawerOta.wirelessVersionName
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#909399",
                                        "font-size": "12px",
                                        "margin-left": "6px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " / wireless " +
                                          _vm._s(
                                            _vm.pinDrawerOta.wirelessVersionName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "h4",
                        {
                          staticStyle: { "margin-top": "0", color: "#303133" },
                        },
                        [_vm._v(_vm._s(_vm.$t("otaFilesExtra.pinnedUsers")))]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.pinListLoading,
                              expression: "pinListLoading",
                            },
                          ],
                        },
                        [
                          _c("pin-list", {
                            attrs: {
                              pins: _vm.pinDrawerPins,
                              "removing-key": _vm.pinRemovingKey,
                            },
                            on: { remove: _vm.removePinFromDrawer },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            color: "#303133",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("otaFilesExtra.addNewPin")))]
                      ),
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "10px" } },
                        [
                          _c("user-search", {
                            attrs: {
                              value: _vm.newPinUserId,
                              placeholder: _vm.$t(
                                "otaFilesExtra.searchUserPlaceholder"
                              ),
                              "show-selected-info": false,
                            },
                            on: { change: _vm.onUserPicked },
                          }),
                        ],
                        1
                      ),
                      _vm.newPinUserLoading
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                                color: "#909399",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.loadingUserDetails")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm.newPinUserId &&
                          _vm.pickedUserDevices.length &&
                          _vm.pinDrawerOta
                        ? _c("pin-form", {
                            key: _vm.newPinUserId + ":" + _vm.pinDrawerOta.id,
                            attrs: {
                              "user-id": _vm.newPinUserId,
                              "user-devices": _vm.pickedUserDevices,
                              "user-pins": _vm.pickedUserPins,
                              "locked-ota-file": _vm.lockedOtaForForm,
                              "allow-user-scope": true,
                            },
                            on: { saved: _vm.onNewPinSaved },
                          })
                        : _vm.newPinUserId &&
                          !_vm.pickedUserDevices.length &&
                          !_vm.newPinUserLoading
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#f56c6c",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("otaFilesExtra.noActiveDevice")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  layout: "total, prev, pager, next",
                  total: _vm.totalItems,
                },
                on: { "current-change": _vm.handlePageChange },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Pinned Devices", name: "pins", lazy: "" } },
            [_c("pinned-devices-panel")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }